import { gql } from '@apollo/client';

export const ALL_MANUAL_CASH_LIMITS_QUERY_NAME = 'AllManualCashLimits';
export const ALL_MANUAL_CASH_LIMITS = gql`
    query ${ALL_MANUAL_CASH_LIMITS_QUERY_NAME}(
        $page: Int, 
        $perPage: Int,
        $sortKey: String,
        $sortDirection: String,
    ) {
        allManualCashLimits(
            page: $page, 
            perPage: $perPage,
            sortKey: $sortKey,
            sortDirection: $sortDirection,
        ) {
            availableMembers {
                name
                memberId
            }
            availableClearingHouses {
                name
                code
                timeZone {
                    ID
                }
            }
            availableCurrencies {
                name
                code
            }
            minCashLimit
            maxCashLimit
            manualCashLimitList {
                totalCount
                models {
                    id
                    member {
                        memberId
                        name
                    }
                    currency {
                        code
                        name
                    }
                    clearingHouse {
                        code
                        name
                    }
                    creator {
                        racf
                        name
                    }
                    limitValue
                    beginDate
                    endDate
                    creationTime
                    description
                }
            }
        }
    }
`;

export const CREATE_MANUAL_CASH_LIMIT = gql`
    mutation CreateManualCashLimit(
        $memberId: String!,
        $clearingHouseCode: String!,
        $currencyCode: String!,
        $limitValue: Price!,
        $beginDate: LocalDate!,
        $endDate: LocalDate,
        $description: String,
        $correlationId: String!,
        $fourEyesUserId: String,
        $fourEyesPassword: String,
        $extraConfirmation: Boolean = false,
    ) {
        createManualCashLimit(
            memberId: $memberId,
            clearingHouseCode: $clearingHouseCode,
            currencyCode: $currencyCode,
            limitValue: $limitValue,
            beginDate: $beginDate,
            endDate: $endDate,
            description: $description,
            correlationId: $correlationId,
            fourEyesUserId: $fourEyesUserId,
            fourEyesPassword: $fourEyesPassword,
            extraConfirmation: $extraConfirmation,
        ) {
            member {
                memberId
                name
            }
        }
    }
`;

export const DELETE_MANUAL_CASH_LIMIT = gql`
    mutation DeleteManualCashLimit(
        $id: Int!, 
        $correlationId: String!,
        $fourEyesUserId: String,
        $fourEyesPassword: String,
    ) {
        deleteManualCashLimit(
            id: $id, 
            correlationId: $correlationId,
            fourEyesUserId: $fourEyesUserId,
            fourEyesPassword: $fourEyesPassword,
        ) {
            member {
                memberId
                name
            }
        }
    }
`;

export const ON_MANUAL_CASH_LIMIT_CHANGED = gql`
    subscription onManualCashLimitChanged {
        manualCashLimitChanged {
            correlationId
            action
            model {
                member {
                    memberId
                    name
                }
            }
        }
    }
`;
